import { AUTH_HEADER, createHttpError, createMetaHeaders, SETTINGS_API_ORIGIN_URL } from "@anydo/core";

//#region Types
interface IProps {
  baseUrl?: string;
  requestName: string;
  authToken: string | null;
  path: string;
  body: any;
  signal?: AbortSignal;
}
//#endregion

export async function makePostRequest({
  baseUrl = SETTINGS_API_ORIGIN_URL,
  requestName,
  authToken,
  path,
  body,
  signal,
}: IProps): Promise<Response> {
  if (!path.startsWith("/")) {
    throw new Error("path is expected to start with a leading /");
  }

  const url = baseUrl + path;

  if (authToken == null) {
    throw new Error(`${requestName}(): missing auth token`);
  }

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      [AUTH_HEADER]: authToken,
      ...createMetaHeaders(),
    },
    body: JSON.stringify(body),
    signal,
  });

  if (!response.ok) {
    throw await createHttpError(response);
  }

  return response;
}
